import DealerError from './DealerError.js'

export class TrackingPhoneError extends DealerError {}
